const ROOT_SELECTOR = '.marketing-insights-root';

const readVar = (name, fallback) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return fallback;
  const root = document.querySelector(ROOT_SELECTOR) || document.documentElement;
  const value = getComputedStyle(root).getPropertyValue(name).trim();
  return value || fallback;
};

export const brandRamp = () => [
  readVar('--setlist-brand-600', '#1982C4'),
  readVar('--setlist-brand-500', '#2A9CE4'),
  readVar('--setlist-brand-400', '#85C6EF'),
  readVar('--setlist-brand-300', '#B2DBF5'),
  readVar('--setlist-brand-200', '#DFF0FB')
];

export const buyerMixPalette = () => [
  readVar('--setlist-brand-600', '#1982C4'),
  readVar('--setlist-brand-400', '#85C6EF'),
  readVar('--setlist-brand-200', '#DFF0FB')
];

export const sourceCategoryPalette = () => [
  readVar('--setlist-brand-600',   '#1982C4'),
  readVar('--setlist-purple-600',  '#6938EF'),
  readVar('--setlist-pink-600',    '#DD2590'),
  readVar('--setlist-success-600', '#8AC926'),
  readVar('--setlist-orange-600',  '#E04F16'),
  readVar('--setlist-warning-500', '#F79009'),
  readVar('--setlist-gray-500',    '#717680')
];

export const purpleRamp = () => ({
  primary:   readVar('--setlist-purple-600', '#6938EF'),
  secondary: readVar('--setlist-purple-500', '#7A5AF8')
});
